import React, { useEffect, useState, useContext } from "react";
import CurrencyFormat from 'react-currency-format';
import "rc-slider/assets/index.css";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

//import api
import { getStackingEstimate } from "../../api/staking";


// lib
import { truncateDecimals } from "../../lib/roundOf";
import isEmpty from "../../lib/isEmpty";
import { currencyChange } from "../../lib/pairHelper";


const StackedDetail = () => {

  const { t, i18n } = useTranslation()

  //REDUX
  const { defaultcurrency } = useSelector((state) => state.account);
  const priceConversion = useSelector((state) => state.priceConversion);

  //state
  const [tradedata, setTradeData] = useState([])
  const [stakeType, setStakeType] = useState('interest')


  const getStackinginfo = async () => {
    try {
      const { status, result } = await getStackingEstimate({ type: stakeType });
      if (status == "success") {
        // console.log(result, "--------result")
        if (result) {
          if (defaultcurrency != "USD") {
            let convetCurrency = priceConversion && priceConversion.length > 0 && priceConversion.find((el) => el.baseSymbol == "USD" && el.convertSymbol == defaultcurrency)
            if (convetCurrency?.convertPrice) {
              let amount = !isEmpty(convetCurrency?.convertPrice) ? parseFloat(convetCurrency?.convertPrice) : 1
              let data = {
                redemption: parseFloat(result?.redemption * amount),
                furueRedemption: parseFloat(result?.furueRedemption * amount),
                futureAmount: parseFloat(result?.futureAmount * amount),
                interest: parseFloat(result?.interest * amount),
                futureInterestYearly: parseFloat(result?.futureInterestYearly * amount)
              }
              setTradeData(data)
            }

          }
          else {
            setTradeData(result)
          }
        }
      } else {
      }
    } catch (err) {
      console.log(err, 'errro');
    }
  };


  useEffect(() => {
    getStackinginfo()
  }, [priceConversion, defaultcurrency, stakeType])

  return (
    <div className="mb-6">
      <div className="row ">
        <div className="col-lg-12">
          <div className="d-flex justify-content-end mb-3" style={{ padding: "0 15px" }}>
            <div className="form-check me-4 d-flex align-items-center">
              <input className="form-check-input me-2" type="radio" name="stakeType" id="interestRadio" value="interest" checked={stakeType === 'interest'} onChange={(e) => setStakeType(e.target.value)} style={{ cursor: "pointer", marginTop: 0 }} />
              <label className="form-check-label" htmlFor="interestRadio" style={{ cursor: "pointer", fontWeight: "600" }}>
                {t("INTEREST") || "Interest"}
              </label>
            </div>
            {/* <div className="form-check d-flex align-items-center">
              <input className="form-check-input me-2" type="radio" name="stakeType" id="autoRestakeRadio" value="auto-restake" checked={stakeType === 'auto-restake'} onChange={(e) => setStakeType(e.target.value)} style={{ cursor: "pointer", marginTop: 0 }} />
              <label className="form-check-label" htmlFor="autoRestakeRadio" style={{ cursor: "pointer", fontWeight: "600", color: "#fff" }}>
                {t("AUTO_RESTAKE") || "Auto-Restake"}
              </label>
            </div> */}
          </div>
          <div className="w-full self-stretch p-4 relative bg-[#F4F3F3] shadow-sm rounded-sm flex flex-wrap lg:flex-nowrap justify-between lg:justify-start items-center gap-y-4 lg:gap-6 overflow-hidden">
            
            <div className="w-[48%] lg:w-auto lg:flex-1 lg:pr-6 lg:border-r border-[#395645]/25 flex flex-col justify-center items-start gap-0.5 relative z-10">
              <div className="justify-center text-[#6b7280] text-sm font-normal font-['Roobert']">{t("TOTAL_EARNED_REDEMPTION")}:</div>
              <div className="justify-center text-[#395645] text-sm font-semibold font-['Roobert']">
                {currencyChange(defaultcurrency)} <CurrencyFormat displayType={'text'} thousandSeparator={true} value={truncateDecimals(tradedata?.redemption, 2)} />
              </div>
            </div>
            <div className="w-[48%] lg:w-auto lg:flex-1 lg:pr-6 lg:border-r border-[#395645]/25 flex flex-col justify-center items-start gap-0.5 relative z-10">
              <div className="justify-center text-[#6b7280] text-sm font-normal font-['Roobert']">{t("INTEREST_PAID")}:</div>
              <div className="justify-center text-[#395645] text-sm font-semibold font-['Roobert']">
                {currencyChange(defaultcurrency)} <CurrencyFormat displayType={'text'} thousandSeparator={true} value={truncateDecimals(tradedata?.interest, 2)} />
              </div>
            </div>
            <div className="w-[48%] lg:w-auto lg:flex-1 lg:pr-6 lg:border-r border-[#395645]/25 flex flex-col justify-center items-start gap-0.5 relative z-10">
              <div className="justify-center text-[#6b7280] text-sm font-normal font-['Roobert']">{t("ESTIMATED_APY_INTEREST")}:</div>
              <div className="justify-center text-[#395645] text-sm font-semibold font-['Roobert']">
                {currencyChange(defaultcurrency)} <CurrencyFormat displayType={'text'} thousandSeparator={true} value={truncateDecimals(tradedata?.futureInterestYearly, 2)} />
              </div>
            </div>
            <div className="w-[48%] lg:w-auto lg:flex-1 lg:pr-6 lg:border-r border-[#395645]/25 flex flex-col justify-center items-start gap-0.5 relative z-10">
              <div className="justify-center text-[#6b7280] text-sm font-normal font-['Roobert']">{t("ESTIMATED_TOTAL_INTEREST")}:</div>
              <div className="justify-center text-[#395645] text-sm font-semibold font-['Roobert']">
                {currencyChange(defaultcurrency)} <CurrencyFormat displayType={'text'} thousandSeparator={true} value={truncateDecimals(tradedata?.furueRedemption, 2)} />
              </div>
            </div>
            <div className="w-[48%] lg:w-auto lg:flex-1 lg:pr-6 flex flex-col justify-center items-start gap-0.5 relative z-10">
              <div className="justify-center text-[#6b7280] text-sm font-normal font-['Roobert']">{t("ESTIMATED_TOTAL_REDEMPTION")}:</div>
              <div className="justify-center text-[#395645] text-sm font-semibold font-['Roobert']">
                {currencyChange(defaultcurrency)} <CurrencyFormat displayType={'text'} thousandSeparator={true} value={truncateDecimals(tradedata?.futureAmount, 2)} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
};

export default StackedDetail;
